import Icon from './Icon';
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/site';

export default function FixedCallBar() {
  return (
    <div className="callbar" role="region" aria-label="Call support">
      <a href={`tel:${SUPPORT_PHONE_TEL}`}>
        <Icon name="phone" size={20} strokeWidth={2} />
        Call Us : {SUPPORT_PHONE}
      </a>
    </div>
  );
}
